import { render, staticRenderFns } from "./ShowCards.vue?vue&type=template&id=0008f782&scoped=true"
import script from "./ShowCards.vue?vue&type=script&lang=js"
export * from "./ShowCards.vue?vue&type=script&lang=js"
import style0 from "./ShowCards.vue?vue&type=style&index=0&id=0008f782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008f782",
  null
  
)

export default component.exports